/* Brinde por faixa de gasto — a metade que roda no navegador.
 *
 * Duas responsabilidades:
 *   1. Manter o medidor honesto depois que o carrinho muda sem recarregar a
 *      pagina. O Liquid desenha o estado certo na primeira carga; a partir
 *      dai quem sabe o total e o /cart.js.
 *   2. A pagina de escolha: janela de tamanho, troca da peca anterior, e a
 *      volta para o carrinho.
 *
 * O limiar NAO esta escrito aqui. Ele chega por data-gift-goal, vindo das
 * configuracoes do tema, que e o mesmo lugar que o carrinho e a pagina de
 * produto leem. Um numero, uma fonte.
 */
(function () {
  'use strict';

  var LOCK = false; // evita duas escolhas simultaneas no duplo clique

  function meters() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-gift-meter]'));
  }

  /* Formato de moeda tirado do proprio Liquid: data-gift-fmt traz o zero ja
     formatado pela loja ("$0.00"), entao prefixo e sufixo saem dali em vez de
     eu assumir dolar. */
  function money(cents, sample) {
    var s = sample || '$0.00';
    var first = s.search(/\d/);
    var last = s.search(/\d(?!.*\d)/);
    var pre = first > 0 ? s.slice(0, first) : '';
    var post = last > -1 ? s.slice(last + 1) : '';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return pre + parts.join('.') + post;
  }

  function handleSet(el) {
    var raw = el.getAttribute('data-gift-handles') || ',';
    return raw;
  }

  /* Soma tudo que NAO e brinde. Contar a peca gratis seria deixar o proprio
     premio pagar o limiar: $40 de compra mais um brinde de $69,90 passaria
     dos $99,90 sozinho. */
  function eligible(cart, handles) {
    var sum = 0;
    var gift = null;
    (cart.items || []).forEach(function (line) {
      var key = ',' + line.handle + ',';
      if (handles.indexOf(key) >= 0) {
        gift = line;
      } else {
        sum += line.final_line_price;
      }
    });
    return { sum: sum, gift: gift };
  }

  function paint(cart) {
    meters().forEach(function (el) {
      var goal = parseInt(el.getAttribute('data-gift-goal'), 10) || 0;
      if (!goal) return;
      var fmt = el.getAttribute('data-gift-fmt') || '$0.00';
      var noun = el.getAttribute('data-gift-noun') || 'free gift';
      var url = el.getAttribute('data-gift-url') || '/';
      var r = eligible(cart, handleSet(el));
      var missing = Math.max(0, goal - r.sum);
      var unlocked = missing <= 0;
      var pct = Math.min(100, goal ? Math.round((r.sum * 100) / goal) : 0);

      var fill = el.querySelector('[data-gift-fill]');
      if (fill) fill.style.width = pct + '%';
      var rail = el.querySelector('.gift-meter__rail');
      if (rail) rail.setAttribute('aria-valuenow', String(pct));

      var say = el.querySelector('[data-gift-say]');
      if (say) {
        if (r.gift && unlocked) {
          say.innerHTML = 'Your ' + noun + ' is in the bag. ' + esc(r.gift.product_title) + ', free.';
        } else if (r.gift) {
          say.innerHTML = '<strong>' + esc(r.gift.product_title) + ' is no longer free.</strong> Add ' +
            money(missing, fmt) + ' more to earn it back, or remove it from the bag.';
        } else if (unlocked) {
          say.innerHTML = 'You have unlocked a ' + noun + '. Pick the one you want.';
        } else {
          say.innerHTML = 'Spend <strong>' + money(missing, fmt) + '</strong> more to unlock a <strong>' + noun + '</strong>.';
        }
      }

      var btn = el.querySelector('[data-gift-btn]');
      if (btn) {
        var want = unlocked
          ? (r.gift ? 'Change it' : el.getAttribute('data-gift-cta'))
          : el.getAttribute('data-gift-locked');
        var next = document.createElement(unlocked ? 'a' : 'span');
        next.className = 'gift-meter__btn' +
          (unlocked ? (r.gift ? ' gift-meter__btn--quiet' : '') : ' gift-meter__btn--off');
        next.setAttribute('data-gift-btn', '');
        if (unlocked) { next.setAttribute('href', url); } else { next.setAttribute('aria-disabled', 'true'); }
        next.textContent = want;
        btn.parentNode.replaceChild(next, btn);
      }

      el.classList.toggle('is-unlocked', unlocked);
      el.classList.toggle('has-gift', !!r.gift);
    });

    lockPicker(cart);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refresh() {
    return getCart().then(paint).catch(function () { /* silencio: o estado do Liquid continua valendo */ });
  }

  /* ----------------------------------------------------------- pagina de escolha */

  var grid = document.querySelector('[data-giftpick]');

  function lockPicker(cart) {
    if (!grid) return;
    var el = document.querySelector('[data-gift-meter]');
    if (!el) return;
    var goal = parseInt(el.getAttribute('data-gift-goal'), 10) || 0;
    var r = eligible(cart, handleSet(el));
    var ok = r.sum >= goal;
    grid.querySelectorAll('[data-gift-pick]').forEach(function (b) {
      b.disabled = !ok;
      b.textContent = ok ? b.getAttribute('data-on') || b.textContent : 'Locked';
    });
  }

  function sizeBox() {
    var box = document.querySelector('.giftsize');
    if (box) return box;
    box = document.createElement('div');
    box.className = 'giftsize';
    box.hidden = true;
    box.innerHTML =
      '<div class="giftsize__veil" data-close></div>' +
      '<div class="giftsize__box" role="dialog" aria-modal="true">' +
      '<button type="button" class="giftsize__close" data-close aria-label="Close">&times;</button>' +
      '<p class="giftsize__title" data-title></p>' +
      '<p class="giftsize__hint">Pick your size. It goes into your bag free.</p>' +
      '<div class="giftsize__sizes" data-sizes></div>' +
      '<p class="giftsize__err" data-err hidden></p>' +
      '</div>';
    document.body.appendChild(box);
    box.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    return box;
  }

  function close() {
    var b = document.querySelector('.giftsize');
    if (b) b.hidden = true;
  }

  function choose(variantId) {
    if (LOCK) return;
    LOCK = true;
    var err = document.querySelector('[data-err]');
    if (err) err.hidden = true;

    var el = document.querySelector('[data-gift-meter]');
    var handles = el ? handleSet(el) : ',';

    /* Troca, nao soma. Se ja existe um brinde no carrinho, ele sai antes do
       novo entrar — senao o cliente acumularia dois e so um ficaria gratis,
       o que ele descobriria no checkout. */
    getCart()
      .then(function (cart) {
        var old = eligible(cart, handles).gift;
        if (!old) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: old.key, quantity: 0 })
        });
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/cart';
      })
      .catch(function () {
        LOCK = false;
        if (err) {
          err.textContent = 'That did not go through. Try again, or pick another size.';
          err.hidden = false;
        }
      });
  }

  if (grid) {
    grid.querySelectorAll('[data-gift-pick]').forEach(function (btn) {
      btn.setAttribute('data-on', btn.textContent.trim());
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-gift-card]');
        if (!card) return;
        var tag = card.querySelector('[data-gift-variants]');
        if (!tag) return;
        var data;
        try { data = JSON.parse(tag.textContent); } catch (e) { return; }

        var box = sizeBox();
        box.querySelector('[data-title]').textContent = data.title;
        var wrap = box.querySelector('[data-sizes]');
        wrap.textContent = '';
        data.variants.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = v.size || v.title;
          b.disabled = !v.available;
          if (v.available) {
            b.addEventListener('click', function () { choose(v.id); });
          }
          wrap.appendChild(b);
        });
        box.hidden = false;
      });
    });
  }

  /* ------------------------------------------------------------- disparadores */

  /* theme.js atualiza [data-cart-count] a cada mudanca do carrinho. Observar
     esse numero e mais confiavel do que torcer para um evento proprio existir,
     e nao exige tocar no theme.js. */
  var badge = document.querySelector('[data-cart-count]');
  if (badge && 'MutationObserver' in window) {
    new MutationObserver(function () { refresh(); }).observe(badge, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  /* A pagina de produto pode vir de cache do navegador com um carrinho ja
     mudado em outra aba. Uma leitura na carga resolve. */
  if (meters().length) refresh();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
